import React from "react";
/**
 * Formats a given date in the form of 01/01/2020
 * seperator can be customized
 */
export var getTextHighlighted = function (text, highlight) {
    if (highlight.length <= 0)
        return React.createElement("span", null, text);
    // Split on highlight term and include term into parts, ignore case
    var escapedHighlights = highlight.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    var parts = text.split(new RegExp("(".concat(escapedHighlights, ")"), "gi"));
    return (React.createElement(React.Fragment, null, parts.map(function (part, i) {
        var highlighted = part.toLowerCase() === highlight.toLowerCase();
        if (highlighted) {
            // eslint-disable-next-line react/no-array-index-key
            return React.createElement("mark", { key: i }, part);
        }
        // eslint-disable-next-line react/no-array-index-key
        return React.createElement("span", { key: i }, part);
    })));
};
